<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Cập nhật hướng dẫn sử dụng</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body ">
        <div class="card-body-scroll">
          <el-form
            :model="mData.dataForm"
            :rules="mData.validForm"
            ref="myForm"
            label-width="100%"
            label-position="top"
          >
            <div class="card card-body__item">
              <div class="card-header">
                <span>Hướng dẫn sử dụng ỨNG DỤNG DU LỊCH VIỆT NAM</span>
              </div>
              <div class="card-body">
                <b-row>
                  <b-col md="6">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <div>
                          <h4>Hướng dẫn sử dụng (Tiếng Việt)</h4>
                        </div>
                      </div>
                      <el-upload
                        :auto-upload="false"
                        list-type="text"
                        action
                        drag
                        :limit="mData.fileUploadOption.HDSDTiengViet.limit"
                        :accept="mData.fileUploadOption.HDSDTiengViet.accept"
                        :on-preview="handlePreviewHDSDTiengViet"
                        :on-remove="handleRemoveHDSDTiengViet"
                        :on-change="handleChangeHDSDTiengViet"
                        :on-exceed="handlExceedHDSDTiengViet"
                        :file-list="mData.fileUploadOption.HDSDTiengViet.fileList"
                        :class="[mData.fileUploadOption.HDSDTiengViet.fileList.length > 0 ? 'disable-upload drag-file  text-center' : 'drag-file text-center']"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Kéo file vào đây hoặc <em>click để upload</em></div>
                        <div class="el-upload__tip text-left" slot="tip">"Chú ý: Định dạng file hỗ trợ pdf, Dung lượng file tối đa không quá 10MB"</div>
                      </el-upload>
                      <p
                        class="error"
                        v-if="!mData.dataForm.HDSDTiengViet.value"
                      >Vui lòng  chọn file đinh kèm</p>
                    </el-card>
                  </b-col>
                  <b-col md="6">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <h4>Hướng dẫn sử dụng (Tiếng Anh)</h4>
                      </div>
                      <el-upload
                        :auto-upload="false"
                        list-type="text"
                        action
                        drag
                        :limit="mData.fileUploadOption.HDSDTiengAnh.limit"
                        :accept="mData.fileUploadOption.HDSDTiengAnh.accept"
                        :on-preview="handlePreviewHDSDTiengAnh"
                        :on-remove="handleRemoveHDSDTiengAnh"
                        :on-change="handleChangeHDSDTiengAnh"
                        :on-exceed="handlExceedHDSDTiengAnh"
                        :file-list="mData.fileUploadOption.HDSDTiengAnh.fileList"
                        :class="[mData.fileUploadOption.HDSDTiengAnh.fileList.length > 0 ? 'disable-upload drag-file text-center' : 'drag-file text-center']"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Kéo file vào đây hoặc <em>click để upload</em></div>
                        <div class="el-upload__tip text-left" slot="tip">"Chú ý: Định dạng file hỗ trợ pdf, Dung lượng file tối đa không quá 10MB"</div>
                      </el-upload>
                      <p
                        class="error"
                        v-if="!mData.dataForm.HDSDTiengAnh.value"
                      >Vui lòng  chọn file đinh kèm</p>
                    </el-card>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="card card-body__item mt-3">
              <div class="card-header">
                <span>Hướng dẫn sử dụng App Quản trị và Kinh doanh Du lịch</span>
              </div>
              <div class="card-body">
                <b-row>
                  <b-col md="6">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <div>
                          <h4>Hướng dẫn sử dụng (Tiếng Việt)</h4>
                        </div>
                      </div>
                      <el-upload
                        :auto-upload="false"
                        list-type="text"
                        action
                        drag
                        :limit="mData.fileUploadOption.HDSDHdvTiengViet.limit"
                        :accept="mData.fileUploadOption.HDSDHdvTiengViet.accept"
                        :on-preview="handlePreviewHDSDHDVTiengViet"
                        :on-remove="handleRemoveHDSDHDVTiengViet"
                        :on-change="handleChangeHDSDHDVTiengViet"
                        :on-exceed="handlExceedHDSDHDVTiengViet"
                        :file-list="mData.fileUploadOption.HDSDHdvTiengViet.fileList"
                        :class="[mData.fileUploadOption.HDSDHdvTiengViet.fileList.length > 0 ? 'disable-upload drag-file  text-center' : 'drag-file text-center']"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Kéo file vào đây hoặc <em>click để upload</em></div>
                        <div class="el-upload__tip text-left" slot="tip">"Chú ý: Định dạng file hỗ trợ pdf, Dung lượng file tối đa không quá 10MB"</div>
                      </el-upload>
                      <p
                        class="error"
                        v-if="!mData.dataForm.HDSDHdvTiengViet.value"
                      >Vui lòng  chọn file đinh kèm</p>
                    </el-card>
                  </b-col>
                  <b-col md="6">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <h4>Hướng dẫn sử dụng (Tiếng Anh)</h4>
                      </div>
                      <el-upload
                        :auto-upload="false"
                        list-type="text"
                        action
                        drag
                        :limit="mData.fileUploadOption.HDSDHdvTiengAnh.limit"
                        :accept="mData.fileUploadOption.HDSDHdvTiengAnh.accept"
                        :on-preview="handlePreviewHDSDHDVTiengAnh"
                        :on-remove="handleRemoveHDSDHDVTiengAnh"
                        :on-change="handleChangeHDSDHDVTiengAnh"
                        :on-exceed="handlExceedHDSDHDVTiengAnh"
                        :file-list="mData.fileUploadOption.HDSDHdvTiengAnh.fileList"
                        :class="[mData.fileUploadOption.HDSDHdvTiengAnh.fileList.length > 0 ? 'disable-upload drag-file text-center' : 'drag-file text-center']"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Kéo file vào đây hoặc <em>click để upload</em></div>
                        <div class="el-upload__tip text-left" slot="tip">"Chú ý: Định dạng file hỗ trợ pdf, Dung lượng file tối đa không quá 10MB"</div>
                      </el-upload>
                      <p
                        class="error"
                        v-if="!mData.dataForm.HDSDHdvTiengAnh.value"
                      >Vui lòng  chọn file đinh kèm</p>
                    </el-card>
                  </b-col>
                </b-row>
              </div>
            </div>
          </el-form>
        </div>
        <b-row>
          <b-col md="12" class="mt-3">
            <div class="text-center">
              <el-button
                type="info"
                plain
                @click="fn_submitForm('update')"
                v-ladda
              >
                {{ aLang.c_update }}
              </el-button>
              <el-button @click="fn_cancel()" type="info" plain>
                {{aLang.csd_cancel}}
              </el-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import ExtensionService from '../../../service/ExtensionService';
import ValidService from '../../../service/ValidService'
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import CauHinhApi from "../../../moduleApi/CauHinhApi";
import FileApi from "../../../moduleApi/FileApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "HDSD",
        changeFileTiengViet: false,
        changeFileTiengAnh: false,
        changeFileHDVTiengViet: false,
        changeFileHDVTiengAnh: false,
        dataDefault: {
          roles: DataService.rolesInForm,
          listQuyen: DataService.accountRoles
        },
        dataForm: {
            HDSDTiengViet: {
                "code": undefined, // required, minLength: 1 Mã của cấu hình
                "roles": [], // optional, array items: required, minLength: 1 Danh sách quyền được phép lấy về thông tin cấu hình
                "value": undefined, // optional Giá trị cấu hình
            },
            HDSDTiengAnh: {
                "code": undefined, // required, minLength: 1 Mã của cấu hình
                "roles": [], // optional, array items: required, minLength: 1 Danh sách quyền được phép lấy về thông tin cấu hình
                "value": undefined, // optional Giá trị cấu hình
            },
          HDSDHdvTiengViet: {
            code: undefined, // required, minLength: 1 Mã của cấu hình
            roles: [], // optional, array items: required, minLength: 1 Danh sách quyền được phép lấy về thông tin cấu hình
            value: undefined, // optional Giá trị cấu hình
          },
          HDSDHdvTiengAnh: {
            code: undefined, // required, minLength: 1 Mã của cấu hình
            roles: [], // optional, array items: required, minLength: 1 Danh sách quyền được phép lấy về thông tin cấu hình
            value: undefined, // optional Giá trị cấu hình
          },
        },
        validForm: {
          HDSDTiengViet: {
            value: [ValidService.requiredChange]
          }
        },
        dataBefore: {
          fileHDSDTiengViet: undefined,
          fileHDSDTiengAnh: undefined,
          fileHDSDHDVTiengViet: undefined,
          fileHDSDHDVTiengAnh: undefined,
        },
        fileHDSDTiengViet: undefined,
        fileHDSDTiengAnh: undefined,
        fileHDSDHDVTiengViet: undefined,
        fileHDSDHDVTiengAnh: undefined,
        fileUploadOption: {
            HDSDTiengViet: {
                limit: 1,
                accept: ".pdf",
                fileList: [],
                fileListBefore: []
            },
            HDSDTiengAnh: {
                limit: 1,
                accept: ".pdf",
                fileList: [],
                fileListBefore: []
            },
          HDSDHdvTiengViet: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
            fileListBefore: [],
          },
          HDSDHdvTiengAnh: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
            fileListBefore: [],
          },
        },
      }
    };
  },
    methods: {
        async fn_initData(){
            this.mData.changeFileTiengViet = false;
            this.mData.changeFileTiengAnh = false;
            this.mData.fileHDSDTiengViet = undefined;
            this.mData.fileHDSDTiengAnh = undefined;
            let code = ["vi_HDSD","en_HDSD"];
            let dataFilter = {
                filters: "code:in:en_HDSD,vi_HDSD"
            }
            const cauHinhApiRes = await CauHinhApi.list(dataFilter);
            if(cauHinhApiRes.result && cauHinhApiRes.result.length > 0){
                this.mData.dataForm.HDSDTiengViet =  cauHinhApiRes.result.find(item => {
                    return item.code == "vi_HDSD"
                })
                if (this.mData.dataForm.HDSDTiengViet.value) {
                    let listFile = await FileApi.findById(this.mData.dataForm.HDSDTiengViet.value);
                    let data = [];
                    if (listFile && listFile.result) {
                        data.push(listFile.result);
                    }
                    this.mData.dataBefore.fileHDSDTiengViet = this.mData.dataForm.HDSDTiengViet.value
                    this.mData.fileUploadOption.HDSDTiengViet.fileList = data;
                    this.mData.fileUploadOption.HDSDTiengViet.fileListBefore = data;
                }
                this.mData.dataForm.HDSDTiengAnh =  cauHinhApiRes.result.find(item => {
                    return item.code == "en_HDSD"
                })
                if (this.mData.dataForm.HDSDTiengAnh.value) {
                    let listFile = await FileApi.findById(this.mData.dataForm.HDSDTiengAnh.value);
                    let data = [];
                    if (listFile && listFile.result) {
                        data.push(listFile.result);
                    }
                    this.mData.dataBefore.fileHDSDTiengAnh = this.mData.dataForm.HDSDTiengViet.value
                    this.mData.fileUploadOption.HDSDTiengAnh.fileList = data;
                    this.mData.fileUploadOption.HDSDTiengAnh.fileListBefore = data;
                }
            }else{
                code.forEach(async item => {
                    let data = {
                        code: item,
                        roles: ["*"],
                        value: undefined,
                    }
                    try {
                        await CauHinhApi.create(data);
                    } catch (error) {
                        console.log(error);
                    }
                })
            }
        },
        async fn_initDataHdv() {
          this.mData.changeFileHDVTiengViet = false;
          this.mData.changeFileHDVTiengAnh = false;
          this.mData.fileHDSDHDVTiengViet = undefined;
          this.mData.fileHDSDHDVTiengAnh = undefined;
          let code = ["vi_HDSD_HDV", "en_HDSD_HDV"];
          let dataFilter = {
            filters: "code:in:vi_HDSD_HDV,en_HDSD_HDV",
          };
          const cauHinhApiRes = await CauHinhApi.list(dataFilter);
          if (cauHinhApiRes.result && cauHinhApiRes.result.length > 0) {
            this.mData.dataForm.HDSDHdvTiengViet = cauHinhApiRes.result.find((item) => {
              return item.code == "vi_HDSD_HDV";
            });
            if (this.mData.dataForm.HDSDHdvTiengViet.value) {
              let listFile = await FileApi.findById(
                this.mData.dataForm.HDSDHdvTiengViet.value
              );
              let data = [];
              if (listFile && listFile.result) {
                data.push(listFile.result);
              }
              this.mData.dataBefore.fileHDSDHDVTiengViet = this.mData.dataForm.HDSDHdvTiengViet.value
              this.mData.fileUploadOption.HDSDHdvTiengViet.fileList = data;
              this.mData.fileUploadOption.HDSDHdvTiengViet.fileListBefore = data;
            }
            this.mData.dataForm.HDSDHdvTiengAnh = cauHinhApiRes.result.find((item) => {
              return item.code == "en_HDSD_HDV";
            });
            if (this.mData.dataForm.HDSDHdvTiengAnh.value) {
              let listFile = await FileApi.findById(
                this.mData.dataForm.HDSDHdvTiengAnh.value
              );
              let data = [];
              if (listFile && listFile.result) {
                data.push(listFile.result);
              }
              this.mData.dataBefore.fileHDSDHDVTiengAnh = this.mData.dataForm.HDSDHdvTiengAnh.value
              this.mData.fileUploadOption.HDSDHdvTiengAnh.fileList = data;
              this.mData.fileUploadOption.HDSDHdvTiengAnh.fileListBefore = data;
            }
          } else {
            code.forEach(async (item) => {
              let data = {
                code: item,
                roles: ["*"],
                value: undefined,
              };
              try {
                await CauHinhApi.create(data);
              } catch (error) {
                console.log(error);
              }
            });
          }
        },
        ///File Tiếng Viet
        handleChangeHDSDTiengViet(file, fileList){
            this.mData.fileHDSDTiengViet = file;
            if(file.name && file.name.toLowerCase().slice(file.name.length - 3,file.name.length) != "pdf"){
                window.toastr.info(
                    `Chỉ tải lên file có định dạng PDF`
                );
                this.mData.fileUploadOption.HDSDTiengViet.fileList = [];
                return
            }
            ExtensionService.upload(file, "HDSD")
            .then(async res => {
                this.mData.dataForm.HDSDTiengViet.value = res.result;
                fileList.forEach((el) => {
                    if (el.uid == file.uid) {
                        el.id = res.result;
                    }
                });
                this.mData.changeFileTiengViet = true;
                this.mData.fileUploadOption.HDSDTiengViet.fileList = fileList;
            })
            .catch(() => {
                this.mData.changeFileTiengViet = false;
                fileList.forEach((el, i) => {
                    if (el.uid == file.uid) {
                        fileList.splice(i, 1);
                    }
                });
            });
        },
        handlePreviewHDSDTiengViet(file){
            window.open(ExtensionService.urlFile + file.id);
        },
        handleRemoveHDSDTiengViet(file, fileList){
            this.mData.dataForm.HDSDTiengViet.value = null;
            this.mData.fileUploadOption.HDSDTiengViet.fileList = [];
            // this.mData.changeFileTiengViet = true;
        },
        handlExceedHDSDTiengViet() {
            window.toastr.info(
                `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSDTiengViet.limit} file`
            );
        },

        ///File Tiếng ANh
        handleChangeHDSDTiengAnh(file, fileList){
            this.mData.fileHDSDTiengAnh = file;
            if(file.name && file.name.toLowerCase().slice(file.name.length - 3,file.name.length) != "pdf"){
                window.toastr.info(
                    `Chỉ tải lên file có định dạng PDF`
                );
                this.mData.fileUploadOption.HDSDTiengAnh.fileList = [];
                return
            }
            ExtensionService.upload(file, "HDSD")
            .then(async res => {
                this.mData.dataForm.HDSDTiengAnh.value = res.result;
                fileList.forEach((el) => {
                    if (el.uid == file.uid) {
                    el.id = res.result;
                    }
                });
                this.mData.changeFileTiengAnh = true;
                this.mData.fileUploadOption.HDSDTiengAnh.fileList = fileList;

            })
            .catch(() => {
                this.mData.changeFileTiengAnh = false;
                fileList.forEach((el, i) => {
                    if (el.uid == file.uid) {
                    fileList.splice(i, 1);
                    }
                });
            });
        },
        handlePreviewHDSDTiengAnh(file){
            window.open(ExtensionService.urlFile + file.id);
        },
        handleRemoveHDSDTiengAnh(){
            this.mData.dataForm.HDSDTiengAnh.value = null;
            this.mData.fileUploadOption.HDSDTiengAnh.fileList = [];
            // this.mData.changeFileTiengAnh = true;
        },
        handlExceedHDSDTiengAnh() {
            window.toastr.info(
                `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSDTiengAnh.limit} file`
            );
        },
        //File HDSV HDV Tiếng Việt
        handleChangeHDSDHDVTiengViet(file, fileList){
          this.mData.fileHDSDHDVTiengViet = file;
          if(file.name && file.name.toLowerCase().slice(file.name.length - 3,file.name.length) != "pdf"){
            window.toastr.info(`Chỉ tải lên file có định dạng PDF`)
            this.mData.fileUploadOption.HDSDHdvTiengViet.fileList = [];
            return
          }
          ExtensionService.upload(file, "HDSD")
          .then(async res => {
            this.mData.dataForm.HDSDHdvTiengViet.value = res.result;
            fileList.forEach((el) => {
              if (el.uid == file.uid) {
                el.id = res.result;
              }
            });
            this.mData.changeFileHDVTiengViet = true;
            this.mData.fileUploadOption.HDSDHdvTiengViet.fileList = fileList;
          })
          .catch(() => {
            this.mData.changeFileHDVTiengViet = false;
            fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
          });
        },
        handlePreviewHDSDHDVTiengViet(file){
          window.open(ExtensionService.urlFile + file.id);
        },
        handleRemoveHDSDHDVTiengViet(file, fileList){
          this.mData.dataForm.HDSDHdvTiengViet.value = null;
          this.mData.fileUploadOption.HDSDHdvTiengViet.fileList = [];
          // this.mData.changeFileHDVTiengViet = true;
        },
        handlExceedHDSDHDVTiengViet() {
          window.toastr.info(
            `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSDHdvTiengViet.limit} file`
          );
        },

         //File HDSV HDV Tiếng Anh
         handleChangeHDSDHDVTiengAnh(file, fileList){
          this.mData.fileHDSDHDVTiengAnh = file;
          if(file.name && file.name.toLowerCase().slice(file.name.length - 3,file.name.length) != "pdf"){
            window.toastr.info(`Chỉ tải lên file có định dạng PDF`)
            this.mData.fileUploadOption.HDSDHdvTiengAnh.fileList = [];
            return
          }
          ExtensionService.upload(file, "HDSD")
          .then(async res => {
            this.mData.dataForm.HDSDHdvTiengAnh.value = res.result;
            fileList.forEach((el) => {
              if (el.uid == file.uid) {
                el.id = res.result;
              }
            });
            this.mData.changeFileHDVTiengAnh = true;
            this.mData.fileUploadOption.HDSDHdvTiengAnh.fileList = fileList;
          })
          .catch(() => {
            this.mData.changeFileHDVTiengAnh = false;
            fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
          });
        },
        handlePreviewHDSDHDVTiengAnh(file){
          window.open(ExtensionService.urlFile + file.id);
        },
        handleRemoveHDSDHDVTiengAnh(file, fileList){
          this.mData.dataForm.HDSDHdvTiengAnh.value = null;
          this.mData.fileUploadOption.HDSDHdvTiengAnh.fileList = [];
          // this.mData.changeFileHDVTiengAnh = true;
        },
        handlExceedHDSDHDVTiengAnh() {
          window.toastr.info(
            `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSDHdvTiengAnh.limit} file`
          );
        },

        fn_cancel(){
          this.mData.fileUploadOption.HDSDTiengViet.fileList = this.mData.fileUploadOption.HDSDTiengViet.fileListBefore;
          this.mData.fileUploadOption.HDSDTiengAnh.fileList = this.mData.fileUploadOption.HDSDTiengAnh.fileListBefore;
          this.mData.fileUploadOption.HDSDHdvTiengViet.fileList = this.mData.fileUploadOption.HDSDHdvTiengViet.fileListBefore;
          this.mData.fileUploadOption.HDSDHdvTiengAnh.fileList = this.mData.fileUploadOption.HDSDHdvTiengAnh.fileListBefore;
          this.mData.dataForm.HDSDTiengViet.value = this.mData.dataBefore.fileHDSDTiengViet
          this.mData.dataForm.HDSDTiengAnh.value = this.mData.dataBefore.fileHDSDTiengAnh
          this.mData.dataForm.HDSDHdvTiengViet.value = this.mData.dataBefore.fileHDSDHDVTiengViet
          this.mData.dataForm.HDSDHdvTiengAnh.value = this.mData.dataBefore.fileHDSDHDVTiengAnh
        },
        async fn_submitForm(type) {
          if (type == "update") {
            if (
              !this.mData.dataForm.HDSDTiengViet.value ||
              !this.mData.dataForm.HDSDTiengAnh.value ||
              !this.mData.dataForm.HDSDHdvTiengViet.value ||
              !this.mData.dataForm.HDSDHdvTiengAnh.value
            ) {
              MethodService.stopLadda()
              return
            }
            if (this.mData.changeFileTiengViet === true) {
              let dataTiengViet = this.mData.dataForm.HDSDTiengViet;
              dataTiengViet.id = this.mData.dataForm.HDSDTiengViet.id;
              try {
                await CauHinhApi.update(dataTiengViet);
                this.fn_initData();
                window.toastr.success("Cập nhật file hướng dẫn sử dụng Tiếng Việt thành công");
                this.mData.changeFileTiengViet = false
              } catch (error) {
                console.log(error);
                window.toastr.error("Cập nhật file hướng dẫn sử dụng Tiếng Việt thất bại");
              }
            }
            if (this.mData.changeFileTiengAnh === true) {
              let dataTiengAnh = this.mData.dataForm.HDSDTiengAnh;
              dataTiengAnh.id = this.mData.dataForm.HDSDTiengAnh.id;
              try {
                await CauHinhApi.update(dataTiengAnh);
                this.fn_initData();
                window.toastr.success("Cập nhật file hướng dẫn sử dụng Tiếng Anh thành công");
                this.mData.changeFileTiengAnh = false
              } catch (error) {
                console.log(error);
                window.toastr.error("Cập nhật file hướng dẫn sử dụng Tiếng Anh thất bại");
              }
            }
            if (this.mData.changeFileHDVTiengViet === true) {
              let dataHDVTiengViet = this.mData.dataForm.HDSDHdvTiengViet;
              dataHDVTiengViet.id = this.mData.dataForm.HDSDHdvTiengViet.id;
              try {
                await CauHinhApi.update(dataHDVTiengViet);
                this.fn_initData();
                window.toastr.success("Cập nhật file hướng dẫn sử dụng Tiếng Việt thành công");
                this.mData.changeFileHDVTiengViet = false
              } catch (error) {
                console.log(error);
                window.toastr.error("Cập nhật file hướng dẫn sử dụng Tiếng Việt thất bại");
              }
            }
            if (this.mData.changeFileHDVTiengAnh === true) {
              let dataHDVTiengAnh = this.mData.dataForm.HDSDHdvTiengAnh;
              dataHDVTiengAnh.id = this.mData.dataForm.HDSDHdvTiengAnh.id;
              try {
                await CauHinhApi.update(dataHDVTiengAnh);
                this.fn_initData();
                window.toastr.success("Cập nhật file hướng dẫn sử dụng Tiếng Anh thành công");
                this.mData.changeFileHDVTiengAnh = false
              } catch (error) {
                console.log(error);
                window.toastr.error("Cập nhật file hướng dẫn sử dụng Tiếng Anh thất bại");
              }
            }
            if (this.mData.changeFileTiengAnh === false && this.mData.changeFileTiengViet === false) {
              MethodService.stopLadda();
              return false;
            }
          }
        },
        fn_resetForm() {
        this.$refs["myForm"].resetFields();
        },
        fn_go() {
        this.$router.go(-1);
        },
        async fn_getDataById(id) {
        let res = await CauHinhApi.findById(id);
        this.mData.dataForm = res.result;
        },
        async fn_initDataDefault() {

        },
    },
    created: function() {
        this.fn_initData()
        this.fn_initDataHdv()
    }
};
</script>
<style scoped>
.error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  margin-bottom: 0;
  margin-top: 10px;
}
h4{
    margin-bottom: 0;
}
.card{
  height: calc(100vh - 110px);
  margin-bottom: 0;
}
.card .card-body__item {
  height: 100%;
}
::v-deep .el-card__header{
    padding: 10px 20px;
}
.d-flex{
    display: flex;
    justify-content: space-between;
}
.card-body-scroll {
  height: calc(100vh - 220px);
  overflow-y: auto;
}
::v-deep .el-upload-list__item {
    transition: none !important;
}
.drag-file{
    max-width: 430px;
    margin: 0 auto;
}
::v-deep .el-upload-list.el-upload-list--text{
    text-align: left;
}
::v-deep .el-upload__tip{
    font-style: italic;
}
</style>
